
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/nri",
      function () {
        return require("private-next-pages/cases/nri/index.tsx");
      }
    ]);
  